import React from "react";
import {inject, observer} from "mobx-react";
import {Alert} from "reactstrap";
import {bandeauComptoir} from "../../../util/terminal";

/**
 * Voyant de l'en-tête, à côté de l'état du serveur d'Event : téléphone du comptoir (SMS, lecteur Zettle) hors ligne
 * ou application fermée. Le détail (heure du dernier contact) est dans l'info-bulle.
 */
const BandeauComptoir = inject("rootStore")(observer(class BandeauComptoir extends React.Component {

    componentDidMount() {
        this.props.rootStore.terminalStore.surveiller();
    }

    componentWillUnmount() {
        this.props.rootStore.terminalStore.arreterSurveillance();
    }

    render() {
        const bandeau = bandeauComptoir(this.props.rootStore.terminalStore.etat);
        if (!bandeau) {
            return null;
        }

        return (
            <Alert color={bandeau.couleur} className="p-1 m-auto ml-2" role="alert" title={bandeau.message}>
                <i className={"fa " + (bandeau.couleur === "danger" ? "fa-exclamation-triangle" : "fa-mobile") + " mr-1"} aria-hidden="true"/>
                {bandeau.court}
            </Alert>
        );
    }
}));

export default BandeauComptoir;
